import React from 'react';
import SidePanelLayout from "layouts/SidePanelLayout";
import MnyWiresPanel from "./MnyWiresPanel";
import MnyWiresFilter from "./MnyWiresFilter";
import {MnyWiresContextProvider} from "./context";

export default function MnyWires() {

    return(<>
        <MnyWiresContextProvider>
            <SidePanelLayout
                sideComponent={MnyWiresFilter}
                mainComponent={MnyWiresPanel}>
            </SidePanelLayout>
        </MnyWiresContextProvider>
    </>);

}